export const RestartIcon = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.99999 3.33335V0.666687L2.66666 4.00002L5.99999 7.33335V4.66669C8.20666 4.66669 9.99999 6.46002 9.99999 8.66669C9.99999 10.8734 8.20666 12.6667 5.99999 12.6667C3.79332 12.6667 1.99999 10.8734 1.99999 8.66669H0.666656C0.666656 11.6134 3.05332 14 5.99999 14C8.94666 14 11.3333 11.6134 11.3333 8.66669C11.3333 5.72002 8.94666 3.33335 5.99999 3.33335Z" />
  </svg>
);
